export const NAME = 'admin';
export const USER_COUPON_FORM = 'userCouponForm';
